<span class="nav-text p-x-10 p-y-2 text-uppercase">{{ text() | translate }}</span>
